export default () => {
    const ua = navigator.userAgent;
    if (((/Android/.test(ua) && /Linux; U;/.test(ua) && !/Chrome/.test(ua)) ||
        (/Android/.test(ua) && /Chrome/.test(ua) && /Version/.test(ua)) ||
        (/Android/.test(ua) && /Chrome/.test(ua) && /SamsungBrowser/.test(ua))) &&
        (!/Trident/.test(ua))) {
            return true;
    }
    return false;
}